import likeIcon from "../assests/images/like_icon.png";
import dislikeIcon from "../assests/images//dislike_icon.png";
import copyIcon from "../assests/images/copy_icon.png";
import shareIcon from "../assests/images/share_icon.png";
import MatchIcon from "../assests/images/matches-icon.png";
import NetworkIcon from "../assests/images/client-network-icon.png";
import ClientPrepIcon from "../assests/images/clinet-preferance-icon.png";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "../Styles/ProfileDisplay.css";
import MenuBar from "./MenuBar";
import SidebarMatches from "./SidebarMatches";

import {
  check_access_request,
  create_matches_by_preference,
  get_access_request,
  get_caste_name,
  get_castes,
  get_communities,
  get_district_cities,
  get_habits,
  get_hobbies,
  get_language,
  get_level1_caste,
  get_level2_caste,
  get_marital_status,
  get_matches_for_client,
  get_physical_build,
  get_profile_byid,
  get_qualification,
  get_relations,
  get_religios,
  get_skin_tone,
  send_access_request,
} from "../api/serverWrapper";
import ClientPreferences from "./ClientPreferences";
import ApprovedProfiles from "./ApprovedProfiles";
import { getData } from "../utils/store-data";
import { AGENT_LOGIN, USER_ID } from "../utils/store-data-constants";
import logo from "../assests/images/menubar_logo.png";
import ProfileDetailsView from "./ProfileDetailsView";
import { useMasterData } from "../context/MasterDataContext";

const allIcons = {
  like_icon: likeIcon,
  dislike_icon: dislikeIcon,
  copy_icon: copyIcon,
  share_icon: shareIcon,
};

const ProfileDisplay = () => {
  const {
    religionMasterData,
    maritalStatusMasterData,
    skinToneMasterData,
    buildMasterData,
    habitsMasterData,
    hobbiesMasterData,
    qualificationMasterData,
    languageMasterData,
    relationsMasterData,
  } = useMasterData();

  const location = useLocation();
  const client = location.state?.client;

  const navigate = useNavigate();

  // console.log("client", client);

  const tabs = [
    { id: "matches", label: "Matches", icon: MatchIcon },
    { id: "network", label: "Client’s Network", icon: NetworkIcon },
    { id: "preferences", label: "Client preferences", icon: ClientPrepIcon },
  ];

  const [activeTab, setActiveTab] = useState("matches");
  const [displayAprrovedProfile, setDisplayAprrovedProfile] = useState(false);

  let [UserData, setUserData] = useState(null);
  const [religion, setReligion] = useState(religionMasterData || []);
  const [languages, setLanguage] = useState(languageMasterData || []);

  const [communityList, setCommunity] = useState([]);
  const [Loading, setLoading] = useState(false);
  let [data, setData] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState(
    maritalStatusMasterData || [],
  );
  const [skinToneList, setSkinToneList] = useState(skinToneMasterData || []);
  const [physicalbuildList, setPhysicalBuildList] = useState(
    buildMasterData || [],
  );
  const [habitList, setHabitList] = useState(habitsMasterData || []);
  const [hobbiesList, setHobbiesList] = useState(hobbiesMasterData || []);
  const [qualifications, setQualifications] = useState(
    qualificationMasterData || [],
  );
  const [relationList, setRelatonList] = useState(relationsMasterData || []);
  const [selectedQualification, setSelectedQualification] = useState(
    UserData?.QualificationId,
  );

  const [isAgentLogin, setIsAgentLogin] = useState(true);
  const [UserId, setUserId] = useState(null);

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);

      let data = await getData(AGENT_LOGIN);

      setIsAgentLogin(data);
      let id = await getData(USER_ID);
      setUserId(id);

      await getProfileByID(client?.ProfileId);

      await loadMathesData(client?.ProfileId);

      setSelectedQualification(UserData?.QualificationId);
      // runMatchesAloritm({ profileId: client.ProfileId });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const runMatchesAloritm = async (data) => {
    let runpreferanceAlogritm = await create_matches_by_preference(data);
    console.log("runpreferanceAlogritm", runpreferanceAlogritm);
    if ((runpreferanceAlogritm.code = 200)) {
      await loadMathesData(client?.ProfileId);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(UserData?.ClientCode);
    showToast("Client code copied!");
  };

  const showToast = (message) => {
    const toast = document.getElementById("toast-message");
    if (!toast) return;

    toast.innerText = message;
    toast.style.display = "block";

    // Force reflow to restart animation
    void toast.offsetWidth;

    toast.style.animation = "fadeInOut 3s ease-in-out";

    // Hide again after animation
    setTimeout(() => {
      toast.style.display = "none";
    }, 3000);
  };

  let [clientPrepData, setclientPrepData] = useState(client);

  async function getProfileByID(id) {
    let resp = await get_profile_byid(id);
    console.log("client main ", resp.data[0]);
    UserData = resp?.data[0];
    setUserData(UserData);

    if (client?.ProfileId === UserData?.ProfileId) {
      clientPrepData = resp?.data[0];
      setclientPrepData(UserData);
    }
  }

  const getCityName = (City) => {
    return City ? City : "City Not added";
  };

  const [casteName, setCasteName] = useState("");

  useEffect(() => {
    async function fetchCasteName() {
      const castename = await get_caste_name(UserData?.CasteLevel2Id);
      setCasteName(castename.data ? castename.data.CasteName : "Not Found");
    }

    if (UserData?.CasteLevel2Id) fetchCasteName();
  }, [UserData?.CasteLevel2Id]);

  const getReligionNameById = (id) => {
    const foundReligion = religion.find((item) => item.ReligionId === id);
    return foundReligion ? foundReligion.ReligionName : "Not Found";
  };
  const getCommunitieNameById = (id) => {
    const foundCommunitie = communityList.find(
      (item) => item.CommunitiesId === id,
    );
    return foundCommunitie ? foundCommunitie.ShortName : "";
  };
  const getMaritalStatusNameById = (id) => {
    const foundMarriageStatus = maritalStatus.find(
      (item) => item.MarriageStatusId === id,
    );
    return foundMarriageStatus ? foundMarriageStatus.MarriageStatus : "";
  };
  const getBuildNameById = (id) => {
    const foundBuildName = physicalbuildList.find(
      (item) => item.BuildId === id,
    );
    return foundBuildName ? foundBuildName.BuildName : "";
  };

  const getSkinToNameById = (id) => {
    const foundSkinTone = skinToneList.find((item) => item.SkinToneId === id);
    return foundSkinTone ? foundSkinTone.SkinToneName : "";
  };

  const loadMathesData = async (id) => {
    try {
      let resp = await get_matches_for_client(id);
      data = resp.data;
      setData(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleProfileId = async (id) => {
    await getProfileByID(id);
    if (client.ProfileId !== UserData.ProfileId) {
      await getAccesRequest(client.ProfileId, id);
      await CheckAccesRequest(id, client.ProfileId);
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth", // optional: makes it animate instead of jumping
    });
  };

  const MoveToApprovedClient = () => {
    setActiveTab("approved");
  };

  const moveToMatches = async (id) => {
    await getProfileByID(id);
    // setActiveTab("matches");
    setDisplayAprrovedProfile(true);
  };

  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (imgSrc) => {
    setSelectedImage(imgSrc);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const sendAccessRequest = async () => {
    console.log("UserData", UserData);

    let data = {
      ProfileId: client.ProfileId,
      ToProfileId: UserData.ProfileId,
      IsAccepted: 1, //Send request
      AgentId: UserData?.BusinessDetails?.UserId,
    };

    let resp = await send_access_request(data);
    console.log("send_access_request ", resp);
    if (resp.code === 200) {
      handleProfileId(UserData.ProfileId);
    }
  };

  const [AccesRequestStatus, setAccesRequestStatus] = useState(null);
  const getAccesRequest = async (ProfileId, ToProfileId) => {
    console.log(ProfileId, ToProfileId);

    let resp = await get_access_request(ProfileId, ToProfileId);
    setAccesRequestStatus(resp?.data?.IsAccepted);
    console.log("getAccesRequest", resp);
  };

  const [CheckAccesRequestStatus, setCheckAccesRequestStatus] = useState(null);
  const CheckAccesRequest = async (ProfileId, ToProfileId) => {
    let resp = await check_access_request(ToProfileId, ProfileId);
    setCheckAccesRequestStatus(resp?.data);
    console.log("CheckAccesRequest", resp);
  };

  const approveTheRequest = async () => {
    let data = {
      RequestId: CheckAccesRequestStatus.RequestId,
      ProfileId: client.ProfileId,
      ToProfileId: UserData.ProfileId,
      IsAccepted: 2, // Approved for the visible photos
    };

    let resp = await send_access_request(data);
    console.log("send_access_request ", resp.data);
    if (resp.code === 200) {
      handleProfileId(UserData.ProfileId);
    }
  };

  if (!UserData)
    return (
      <div className="loading-screen">
        <img src={logo} alt="Logo" className="logo-3d" />
      </div>
    );

  return (
    <div className="main-wrapper">
      <MenuBar />

      <div className="profile_display">
        <div className="tab-container shadow-sm p-3 rounded-top-4 bg-white">
          <div className="d-flex align-items-center justify-content-between">
            <div
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center pe-3 border-end click-effect"
              onClick={() => {
                handleProfileId(client?.ProfileId);
                setActiveTab("matches");
                loadMathesData(client?.ProfileId);
              }}
            >
              {client?.User?.ProfilePhotoUrl ? (
                <img
                  src={client?.User?.ProfilePhotoUrl}
                  alt="profile"
                  className="clinet-pro me-2"
                  width="40"
                  height="40"
                />
              ) : (
                <img
                  src={
                    client?.User?.Gender === 1
                      ? require("../assests/images/MaleDefaultIcon.png")
                      : require("../assests/images/FeMaleDefaultIcon.png")
                  }
                  alt="profile"
                  className="clinet-pro me-2"
                  width="40"
                  height="40"
                />
              )}
              <span className="fw-medium">
                {" "}
                {client?.User?.FirstName} {client?.User?.LastName}
              </span>
            </div>

            <div className="d-flex flex-wrap ms-3 gap-2">
              {tabs.map((tab) => (
                <div className="tab-wrapper" key={tab.id}>
                  <button
                    onClick={() => {
                      setActiveTab(tab.id);
                      setDisplayAprrovedProfile(false);
                    }}
                    className={`custom-tab ${
                      activeTab === tab.id ? "active" : ""
                    }`}
                  >
                    <img
                      src={tab.icon}
                      alt=""
                      className="tabs-icons-for-profile"
                    />
                    {tab.id === "preferences"
                      ? isAgentLogin
                        ? "Client preferences"
                        : "Match preferences"
                      : tab.id === "network"
                        ? isAgentLogin
                          ? "Client’s Network"
                          : "My Network"
                        : tab.label}
                  </button>
                </div>
              ))}
            </div>
          </div>
          <hr className="mt-3 mb-0" />
        </div>
        {activeTab === "matches" && (
          <div className="profile-container">
            {/* Sidebar */}

            {!displayAprrovedProfile && (
              <SidebarMatches
                data={data}
                allIcons={allIcons}
                loadMathesData={loadMathesData}
                client={client}
                MoveToApprovedClient={MoveToApprovedClient}
                handleProfileId={handleProfileId}
                loading={Loading}
                setLoading={setLoading}
                isAgentLogin={isAgentLogin}
                initialTab={location.state?.matchesTab}
              />
            )}

            <ProfileDetailsView
              UserData={UserData}
              client={client}
              navigate={navigate}
              AccesRequestStatus={AccesRequestStatus}
              CheckAccesRequestStatus={CheckAccesRequestStatus}
              approveTheRequest={approveTheRequest}
              handleCopy={handleCopy}
              openModal={openModal}
              sendAccessRequest={sendAccessRequest}
              isAgentLogin={isAgentLogin}
              UserId={UserId}
              relationList={relationList}
              qualifications={qualifications}
              selectedQualification={selectedQualification}
              habitList={habitList}
              hobbiesList={hobbiesList}
              casteName={casteName}
              languages={languages}
              getReligionNameById={getReligionNameById}
              getCityName={getCityName}
              getMaritalStatusNameById={getMaritalStatusNameById}
              getBuildNameById={getBuildNameById}
              getSkinToNameById={getSkinToNameById}
            />
          </div>
        )}

        {activeTab === "preferences" && (
          <div className="profile-container">
            <ClientPreferences UserData={clientPrepData} />
          </div>
        )}
        {activeTab === "approved" && (
          <div className="profile-container">
            {!displayAprrovedProfile ? (
              <ApprovedProfiles profiles={data} moveToMatches={moveToMatches} />
            ) : (
              <ProfileDetailsView
                {...{
                  UserData,
                  client,
                  navigate,
                  AccesRequestStatus,
                  CheckAccesRequestStatus,
                  approveTheRequest,
                  handleCopy,
                  openModal,
                  sendAccessRequest,
                  isAgentLogin,
                  UserId,
                  relationList,
                  qualifications,
                  selectedQualification,
                  habitList,
                  hobbiesList,
                  casteName,
                  languages,
                  getReligionNameById,
                  getCityName,
                  getMaritalStatusNameById,
                  getBuildNameById,
                  getSkinToNameById,
                }}
                showBack
                onBack={() => setDisplayAprrovedProfile(false)}
              />
            )}
          </div>
        )}

        {activeTab === "network" && (
          <div className="profile-container  d-flex justify-content-center pt-4">
            <div className="title">Coming Soon</div>
          </div>
        )}

        {selectedImage && (
          <div className="image-modal" onClick={closeModal}>
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={selectedImage} alt="Full view" />
              <button className="close-btn" onClick={closeModal}>
                ×
              </button>
            </div>
          </div>
        )}
      </div>

      <div id="toast-message"></div>
    </div>
  );
};

export default ProfileDisplay;
